import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import colors from 'utils/colors'
import { BUTTONS, EXPLANATIONS, FORM, TITLES } from 'locales/locales'

import CustomText from 'components/text/CustomText'
import CustomButton from 'components/button/CustomButton'


interface IKVKKModalProps {
  privacyText: string
  onAccept: () => void
  onReject: () => void
  onClose: () => void
}

const KVKKModal: React.FC<IKVKKModalProps> = ({
  privacyText,
  onAccept,
  onReject,
  onClose,
}) => {
  const { t } = useTranslation()



  const handleAccept = () => {
    onAccept()
  }

  const handleReject = () => {
    onReject()
  }


  return (

      <ContentWrapper>
        <KVKKTextContainer>
          <CustomText typography="body3" color={colors.gray80}>
            {privacyText}
          </CustomText>
        </KVKKTextContainer>

        <InfoBox>
          <CustomText typography="body4" color={colors.primaryVime}>
            <b>{t(FORM.KVKK)}</b>
            <br />
            {t(EXPLANATIONS.KVKK_EXPLAINATION)}
          </CustomText>
        </InfoBox>

        <ButtonsWrapper>
          <CustomButton text={t(BUTTONS.REJECT)} type="secondary" typography="body4" onClick={handleReject} />
          <CustomButton text={t(BUTTONS.ACCEPT)} type="primary" typography="body4" onClick={handleAccept} />
        </ButtonsWrapper>
      </ContentWrapper>
   
  )
}

export default KVKKModal

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-height: 70vh;
  padding: 40px
`

const KVKKTextContainer = styled.div`
  background-color: ${colors.white};
  padding: 20px;
  border-radius: 8px;
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid ${colors.light90};
  line-height: 1.6;
  
  /* Scrollbar styling */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: ${colors.light90};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.gray60};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.gray80};
  }
`

const InfoBox = styled.div`
  background-color: rgba(52, 152, 219, 0.1);
  padding: 15px;
  border-radius: 8px;
  border-left: 4px solid ${colors.primaryVime};
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding-top: 10px;
  border-top: 1px solid ${colors.light80};
`
